import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as dataSourcesOrganic from "./dataSourcesOrganic.actions";
import {exhaustMap, forkJoin, map, Observable, switchMap, withLatestFrom} from 'rxjs';
import {ChannelsService} from "../../services/channels.service";
import {loadDataSourcesAd} from "../dataSourcesAd/dataSourcesAd.actions";
import {Serializer} from '../../interfaces/serializer';
import {Site} from '../../interfaces/site';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';
import {Store} from '@ngrx/store';
import {AppState} from '../store';

@Injectable()
export class DataSourcesOrganicEffects {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);

  public load$ = createEffect(() => this._actions$.pipe(
    ofType(dataSourcesOrganic.loadDataSourcesOrganic),
    withLatestFrom(this._dataset$),
    switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]) => forkJoin([
        this._channelS.getChannels(dataset),
        this._channelS.getChannelTypes()
      ])
      .pipe(
        map(([channels, types]) => dataSourcesOrganic.loadDataSourcesOrganicSuccess({
          dataSources: channels.data,
          types: types.data
        }))
      )
    )
  ));

  public delete$ = createEffect(() => this._actions$.pipe(
    ofType(dataSourcesOrganic.deleteDataSourceOrganic),
    withLatestFrom(this._dataset$),
    exhaustMap(([action, dataset]) => this._channelS.deleteOrganicChannel(dataset, action.dataSource.id).pipe(
      switchMap(_ => [
        dataSourcesOrganic.deleteDataSourceOrganicSuccess({
          dataSource: action.dataSource
        }),
        loadDataSourcesAd()
      ])
    ))
  ));

  public create$ = createEffect(() => this._actions$.pipe(
    ofType(dataSourcesOrganic.createDataSourceOrganic),
    withLatestFrom(this._dataset$),
    exhaustMap(([action, dataset]) => this._channelS.createOrganicChannel(dataset, action.dataSource).pipe(
      switchMap((result) => [
        dataSourcesOrganic.createDataSourceOrganicSuccess({
          dataSource: result.data
        }),
        loadDataSourcesAd()
      ])
    ))
  ));

  public update$ = createEffect(() => this._actions$.pipe(
    ofType(dataSourcesOrganic.updateDataSourceOrganic),
    withLatestFrom(this._dataset$),
    exhaustMap(([action, dataset]) => this._channelS.updateOrganicChannel(dataset, action.dataSource.id, action.update).pipe(
      switchMap((result) => [
        dataSourcesOrganic.updateDataSourceOrganicSuccess({
          dataSource: result.data
        }),
        loadDataSourcesAd()
      ])
    ))
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _actions$: Actions,
    private readonly _channelS: ChannelsService
  ) {}
}
